import React from 'react'

import customAgent from './img/custom-agent.jpg'

import azafran from './img/despachantes/azafran.jpg'
import bazarHindu from './img/despachantes/bazar-hindu.jpg'
import chane from './img/despachantes/chane.jpg'
import consorcioLegumbres from './img/despachantes/consorcio-legumbres.jpg'
import elgMan from './img/despachantes/elg-man.png'
import gentec from './img/despachantes/gentec.png'
import legitel from './img/despachantes/legitel.jpg'
import marceloElena from './img/despachantes/marcelo-elena.png'
import rincon from './img/despachantes/rincon.jpg'
import solucionesHidrotermicas from './img/despachantes/solucionesHidrotermicas.jpg'
import sur from './img/despachantes/sur.jpg'
import tegoFundaciones from './img/despachantes/tego-fundaciones.jpg'
import temet from './img/despachantes/Temetlogo.jpg'
import vishnu from './img/despachantes/vishnu.png'
import vixonic from './img/despachantes/vixonic.jpg'


import brCargas from './img/agentes/br-cargas.jpg'
import centauro from './img/agentes/centauro.jpg'
import coopercau from './img/agentes/coopercau.jpg'
import drangus from './img/agentes/drangus.jpg'
import flaucar from './img/agentes/flaucar.png'
import framexGroup from './img/agentes/framex-group.png'
import giva from './img/agentes/giva.png'
import hellman from './img/agentes/hellman.png'
import interAmerican from './img/agentes/inter-american.jpg'
import jas from './img/agentes/jas.png'
import jsl from './img/agentes/jsl.jpg'
import mena from './img/agentes/mena.png'
import overseas from './img/agentes/overseas.png'
import plimor from './img/agentes/plimor.jpg'
import pontevedra from './img/agentes/pontevedra.jpg'
import rivatrans from './img/agentes/rivatrans.jpg'
import roheling from './img/agentes/roehling.jpg'
import transco from './img/agentes/transco.png'


const Customers = () => {




  return (<section className="about-details-area section-padding wow fadeIn" id="clients-link">
<div className="container">
    <div className="row">
        <div className="col-md-6 col-lg-6 col-md-offset-3 col-lg-offset-3 col-sm-12 col-xs-12">
            <div className="area-title text-center">
                <h2>Nuestros Clientes</h2>
                <p>En este espacio queremos agradecer a todos nuestros clientes, quienes son el fundamento de nuestras tareas diarias; por su confianza y fidelidad.</p>
            </div>
        </div>
    </div>
    <div className="row">
        <div className="col-md-12 col-xs-12">
            <ul className="about-details-menu">
                <li className=""><a data-toggle="tab" href="#despachante" aria-expanded="false" style={{minWidth: 260, letterSpacing: 1, fontSize: 'medium', fontWeight: 'bold'}}>Despachantes de Aduana</a></li>
                <li className=""><a data-toggle="tab" href="#agente-aduanero" aria-expanded="false" style={{minWidth: 260, letterSpacing: 1, fontSize: 'medium', fontWeight: 'bold'}}>Agentes Aduaneros</a></li>
            </ul>
        </div>
    </div>
    <div className="row wow slideInLeft">
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
            <div className="tab-content about-details-content">
            <div id="agente-aduanero" className="company-history tab-pane fade">
                <div className="row">
                <div style={{ display: 'flex', fleDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-around'}}>
                    <img className="img-responsive img-logo-tcc" src={brCargas}></img>
                    <img className="img-responsive img-logo-tcc"  src={centauro}></img>
                    <img className="img-responsive img-logo-tcc" src={coopercau}></img>
                    <img className="img-responsive img-logo-tcc" src={drangus}></img>
                    <img className="img-responsive img-logo-tcc" src={flaucar}></img>
                    <img className="img-responsive img-logo-tcc" src={framexGroup}></img>
                    <img className="img-responsive img-logo-tcc" src={giva}></img>
                    <img className="img-responsive img-logo-tcc" src={hellman}></img>
                    <img className="img-responsive img-logo-tcc" src={interAmerican}></img>
                    <img className="img-responsive img-logo-tcc" src={jas}></img>
                    <img className="img-responsive img-logo-tcc" src={jsl}></img>
                    <img className="img-responsive img-logo-tcc" src={mena}></img>
                    <img className="img-responsive img-logo-tcc" src={overseas}></img>
                    <img className="img-responsive img-logo-tcc" src={plimor}></img>
                    <img className="img-responsive img-logo-tcc" src={pontevedra}></img>
                    <img className="img-responsive img-logo-tcc" src={rivatrans}></img>
                    <img className="img-responsive img-logo-tcc" src={roheling}></img>
                    <img className="img-responsive img-logo-tcc" src={transco}></img>
                  </div>            
                  </div>
                </div>
                <div id="despachante" className="company-history tab-pane fade">
                <div className="row">
                  <div style={{ display: 'flex', fleDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-around'}}>
                    <img className="img-responsive img-logo-tcc" src={azafran}></img>
                    <img className="img-responsive img-logo-tcc"  src={bazarHindu}></img>
                    <img className="img-responsive img-logo-tcc" src={chane}></img>
                    <img className="img-responsive img-logo-tcc" src={consorcioLegumbres}></img>
                    <img className="img-responsive img-logo-tcc" src={elgMan}></img>
                    <img className="img-responsive img-logo-tcc" src={gentec}></img>
                    <img className="img-responsive img-logo-tcc" src={legitel}></img>
                    <img className="img-responsive img-logo-tcc" src={marceloElena}></img>
                    <img className="img-responsive img-logo-tcc" src={rincon}></img>
                    <img className="img-responsive img-logo-tcc" src={solucionesHidrotermicas}></img>
                    <img className="img-responsive img-logo-tcc" src={sur}></img>
                    <img className="img-responsive img-logo-tcc" src={tegoFundaciones}></img>
                    <img className="img-responsive img-logo-tcc" src={temet}></img>
                    <img className="img-responsive img-logo-tcc" src={vishnu}></img>
                    <img className="img-responsive img-logo-tcc" src={vixonic}></img>
                  </div>
                </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</section>)
}

export default Customers